export const API_GET_OPCOES_ACORDO = '@negociar/GET_OPCOES_ACORDO';
export const API_REALIZAR_ACORDO = '@negociar/REALIZAR_ACORDO';

export const SET_OPCOES_PAGAMENTO = '@negociar/SET_OPCOES_PAGAMENTO';
export const SELECT_OPCAO_PAGAMENTO = '@negociar/SELECT_OPCA_PAGAMENTO';
export const SET_PAGE_VIEW_ACTIONS = '@negociar/SET_PAGE_VIEW_ACTIONS';
export const SET_DIALOG_PAGE_VIEW = '@negociar/SET_DIALOG_PAGE_VIEW';
export const SET_DADOS_CARTAO_CREDITO = '@negociar/SET_DADOS_CARTAO_CREDITO';
export const SET_GLOBAL_VALUES = '@negociar/SET_GLOBAL_VALUES';
